import Swiper, { Autoplay } from "swiper";

Swiper.use([Autoplay]);

export default class LogosMarquee {
  init() {
    const marquees = document.querySelectorAll("[data-logos-marquee]");

    if (!marquees.length) return;

    marquees.forEach((marquee) => {
      const swiperEl = marquee.querySelector(".logos-swiper");

      if (!swiperEl) return;

      new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        speed: 4000, // lower value -> faster
        allowTouchMove: false,

        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },

        breakpoints: {
          1024: {
            spaceBetween: 32,
          },
        },
      });
    });
  }
}
